module.exports = __webpack_public_path__ + "741ac941aec4db69cb44deff86eade7c.gif";